import { useState } from 'react';
import axios from 'axios';

const usePost = (withHeaderJson = true) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postData = async (url, payload) => {
        setLoading(true);
        setError(null);
        setData(null); // ✅ إعادة تعيين البيانات السابقة
        
        const token = localStorage.getItem('token');
        
        const headers = withHeaderJson ? {
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': `Bearer ${token}`
        } : {
            'Authorization': `Bearer ${token}`
        };

        try {
            const response = await axios.post(url, payload, { headers });
            setData(response.data);
            console.log('Post Request:', 'URL:', url, 'PAYLOAD:', payload, 'RESPONSE:', response.data);
        } catch (err) {
            setError(err);
            console.error('Post Error:', err.response?.data || err.message);
            
            // ✅ معالجة أخطاء محددة
            if (err.response?.status === 403) {
                console.error('403 Forbidden: Check your permissions');
            } else if (err.response?.status === 401) {
                console.error('401 Unauthorized: Token may be invalid or expired');
            }
        } finally {
            setLoading(false);
        }
    };

    return { data, loading, error, postData };
};

export default usePost;